import React, { FC } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'

import { useReferentiel, useOrganisationKAMUsers, useOrganisationAll } from 'api'
import { Select, Period, SelectOption, SelectReact } from 'components/atoms'
import {
  setCountry,
  setBusinessUnit,
  setStartYear,
  setEndYear,
  getFilters,
  setValidationStatus,
  setKamUserId,
  setEnergy,
} from 'store/selection'
import { CheckBoxGroup, CheckBoxOption } from 'components/atoms/CheckBoxGroup'
import { Label } from 'reactstrap'

export const ContractFilters: FC = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { country, startYear, endYear, validationStatus, kamUserId, energy, businessUnit } =
    useSelector(getFilters)

  const { ListePays, ListValidationStatus, ListeEnergie } = useReferentiel()
  const organisationUsers = useOrganisationKAMUsers()
  const org = useOrganisationAll()

  const listeOrganisations = (org?.UorEnfants || []).map(
    (uor) =>
      ({
        value: uor.id,
        label: uor.UorNom,
      } as SelectOption),
  )

  const listeUsers = (organisationUsers || []).map(
    (user) => ({ value: user.Id, label: `${user.Prenom} ${user.Nom}` } as SelectOption),
  )

  return (
    <div
      css={{
        display: 'grid',
      }}
    >
      <div
        css={{
          display: 'flex',
          '>*': {
            marginBottom: '2rem',
            '&:not(:last-child)': {
              marginRight: '1rem',
            },
          },
        }}
      >
        <CheckBoxGroup
          options={ListeEnergie.map(
            (energie) =>
              ({
                id: energie.value,
                name: energie.label,
                value: energie.value,
                label: energie.label,
              } as CheckBoxOption),
          )}
          selectedValues={energy ? [energy] : []}
          onChange={(newValues: any[]) => {
            const singleValue = newValues.length > 0 ? newValues[newValues.length - 1] : null
            dispatch(setEnergy(singleValue))
          }}
          id="energieContract"
          label={t('global.energy')}
        />
      </div>
      <div
        css={{
          display: 'flex',
          '>*': {
            marginBottom: '2rem',
            '&:not(:last-child)': {
              marginRight: '1rem',
            },
          },
        }}
      >
        {listeOrganisations.length > 1 && (
          <div style={{ width: '100%', marginBottom: '1rem' }}>
            <Label for="valueBusinessUnits" css={{ padding: 0 }}>
              {t('global.client')}
            </Label>
            <SelectReact
              isMulti={true}
              value={listeOrganisations.filter(
                (opt) => businessUnit && businessUnit.includes(opt.label as string),
              )}
              placeholder={t('global.client')}
              options={listeOrganisations}
              id="valueBusinessUnits"
              onChange={(selectedOptions: any) => {
                const labels = selectedOptions ? selectedOptions.map((opt: any) => opt.label) : []
                dispatch(setBusinessUnit(labels))
              }}
              isClearable={false}
              width="100%"
              bordered
            />
          </div>
        )}
      </div>
      <div
        css={{
          display: 'flex',
          '>*': {
            marginBottom: '2rem',
            '&:not(:last-child)': {
              marginRight: '1rem',
            },
          },
        }}
      >
        {ListePays.length > 1 && (
          <Select
            label={t('global.country')}
            value={country}
            onChange={(id: any) => dispatch(setCountry(id))}
            options={ListePays}
          />
        )}
      </div>

      <div
        css={{
          display: 'flex',
          '>*': {
            '&:not(:last-child)': {
              marginRight: '2rem',
              marginBottom: '1rem',
            },
          },
        }}
      >
        <Period
          start={startYear}
          end={endYear}
          setStart={(year) => dispatch(setStartYear(year))}
          setEnd={(year) => dispatch(setEndYear(year))}
        />

        {ListValidationStatus.length > 1 && (
          <Select
            label={t('contract.infos.labels.validationStatus')}
            value={validationStatus}
            onChange={(id: any) => dispatch(setValidationStatus(id))}
            options={ListValidationStatus}
          />
        )}
      </div>
      <div
        css={{
          display: 'flex',
          '>*': {
            '&:not(:last-child)': {
              marginRight: '2rem',
            },
          },
        }}
      >
        {listeUsers.length > 0 && (
          <Select
            label={t('contract.infos.labels.kam')}
            value={kamUserId}
            onChange={(id: any) => dispatch(setKamUserId(id))}
            options={listeUsers}
          />
        )}
      </div>
    </div>
  )
}
